import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Player } from 'ThreeTerminal_mobile_dynamic';
import { h5PageCount } from 'ThreeTerminal_utils';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { callApp } from '@ifeng-fe/callapp';

let pageWidth = 375;

if (typeof document === 'object') {
    pageWidth = document.documentElement.clientWidth > 812 ? 812 : document.documentElement.clientWidth;
}
const videoWidth = Math.floor((pageWidth * 9) / 16);

class Video extends React.PureComponent {
    static propTypes = {
        videoConfig: PropTypes.object,
        pageInfo: PropTypes.object,
        pageType: PropTypes.string,
    };

    state = {
        isShowVideoFix: false,
    };

    playermsg = {
        auth: true,
        showTitle: true,
        showPoster: true,
        showController: true,
        height: videoWidth,
    };

    handleClick = (isCount) => {
        const { pageInfo } = this.props;
        const doc_type = pageInfo.type === 'article' ? 'doc' : pageInfo.type;
        const aid = pageInfo._id || pageInfo.base62Id;
        const client = pageInfo.isVideoShare ? 'videoApp' : 'newsApp';

        if (isCount) h5PageCount([pageInfo.actionCount]);
        callApp({
            client,
            docType: doc_type,
            pid: aid,
            kind: 'default_videohike',
        });
    };

    UNSAFE_componentWillMount() {
        const { pageInfo } = this.props;

        if (pageInfo && pageInfo.clickCount) {
            this.playermsg.clickVideoStatisticsCB = () => {
                h5PageCount([pageInfo.clickCount]);
            };
        }
        if (pageInfo && pageInfo.firstPlayCount) {
            this.playermsg.firstFrameStatisticsCB = () => {
                h5PageCount([pageInfo.firstPlayCount]);
            };
        }
    }

    render() {
        const { videoConfig, pageInfo, pageType } = this.props;

        if (videoConfig.title) this.playermsg.tips = videoConfig.title;
        this.playermsg.tips = false;

        return (
            <div className={`${styles.video} ${pageType === 'short' ? styles.videoShort : ''}`}>
                <Player videoConfig={videoConfig} playermsg={this.playermsg} />
            </div>
        );
    }
}

export default errorBoundary(Video);
